//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'SerumSodiumCorrected',
  data () {
    return {
      dataList: [
        { value: '0', name: '男' },
        { value: '1', name: '女' }
      ],
      dataList1: [
        {value: '0', name: '<18'},
        {value: '1', name: '18-65'},
        {value: '2', name: '>=65'}
      ],
      dataList2: [
        {value: '0', name: '5%葡萄糖'},
        {value: '34', name: '0.2%NaCl'},
        {value: '77', name: '0.45%NaCl'},
        {value: '130', name: '乳酸林格氏液'},
        {value: '154', name: '0.9%NaCl'},
        {value: '308', name: '1.8%NaCl'},
        {value: '513', name: '3%NaCl'},
        {value: '855', name: '5%NaCl'},
        {value: '1282', name: '7.5%NaCl'}
      ],
      form: {
        gender: '',
        age: '',
        weight: '',
        na: '',
        targetNa: '',
        cRate: '',
        fluid: '',
        kalium: ''
      },
      hasScore: false,
      disabled: false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    showTips () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      if (form.cRate > 0.5) {
        return Boolean(true)
      } else {
        return Boolean(false)
      }
    },
    /** 补液速度 */
    replenishRate () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        let result = 1000 * (form.cRate / this.replenishK)
        console.log(form, result, 'result')
        self.hasScore = true
        return String(result.toFixed(2))
      }
    },
    // 每升补液的Na纠正量
    replenishK () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // gender 0 男 1 女
        // age 0 <18  1 18-65  2 >65

        //   系数：儿童（＜18岁）：0.6
        //  男性（18~65岁）：0.6
        //  女性（18~66岁）：0.5
        //  男性（＞65岁）：0.5
        //  女性（＞65岁）：0.4
        let num = ''
        if (form.age === 0 || (form.age == 2 && form.gender === 0)) {
          num = 0.6
        } else if ((form.gender === 0 && form.age == 1) || (form.age == 2 && form.gender === 1)) {
          num = 0.5
        } else if (form.gender === 1 && form.age == 2) {
          num = 0.4
        }
        let result = (form.fluid + form.kalium - form.na) / [(num * form.weight) + 1]
        console.log(form, num, result, 'result')
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/SerumSodiumCorrected.vue